import * as React from 'react';
import { Button } from '@cian/ui-kit';

interface IToggleTagsButtonProps {
  allTagsLength: number;
  displayTagsLength: number;
  onClick: () => void;
}

export const ToggleTagsButton: React.FC<IToggleTagsButtonProps> = ({ allTagsLength, displayTagsLength, onClick }) => {
  const tagsExpanded = allTagsLength === displayTagsLength;

  return (
    <Button size="XS" theme="fill_white_primary" onClick={onClick} data-testid="ToggleTagsButton">
      {tagsExpanded ? 'Скрыть' : `Ещё ${allTagsLength - displayTagsLength}`}
    </Button>
  );
};
